class FamilyPickerSegmented extends HTMLElement {
  constructor() {
    super();
    this.init = this.init.bind(this);
  }

  connectedCallback() {
    if (document.readyState === "complete") {
      this.init();
    } else {
      window.addEventListener("load", this.init, { once: true });
    }
  }

  disconnectedCallback() {
    window.removeEventListener("load", this.init);
  }

  init() {
    if (window.matchMedia("(min-width: 768px)").matches) return;
    const list = this.querySelector(".swatch-segmented");
    if (!list) return;
    const active = list.querySelector(".variant-input.active");
    if (!active) return;
    const listRect = list.getBoundingClientRect();
    const activeRect = active.getBoundingClientRect();
    if (activeRect.left >= listRect.left && activeRect.right <= listRect.right) return;
    const target = active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2;
    const max = list.scrollWidth - list.clientWidth;
    list.scrollLeft = Math.max(0, Math.min(max, target));
  }
}

customElements.define("family-picker-segmented", FamilyPickerSegmented);
